/**
 * Component Name: TikTok Embed
 * This component takes in a TikTok video Id and renders a TikTok iFrame embed.
 */
import { useEffect, useRef } from 'react';
import styles from './TiktokEmbed.module.scss';

interface ITiktokEmbedProps {
  videoId: string;
  iframeTitle: string;
}

export default function TiktokEmbed({ videoId, iframeTitle }: ITiktokEmbedProps) {
  // Ref for focus management
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    containerRef?.current?.focus();
  });

  return (
    <div className={styles.tikTokEmbedWrapper}>
      <div
        className={styles.iFrameContainerTiktok}
        role="region"
        aria-label={iframeTitle}
        ref={containerRef}
        tabIndex={-1}
      >
        <iframe
          title={iframeTitle}
          src={`https://www.tiktok.com/embed/${videoId}`}
          sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts allow-top-navigation allow-same-origin"
          allow="autoplay; encrypted-media; picture-in-picture"
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>
    </div>
  );
}
